let bookmarks = {

    //current bookmarks
    bookmarksList: [],

    addBookmark: function (id) {
        // check whether page has already been saved *************** TODO
        if (!this.isStored(id)) {
            // add page to bookmarks list
            this.bookmarksList.push(id);
            // save updated list in local storage
            this.store();
            // mark link as added
            this.setStatus();
            // bookmark added; show confirmation modal
            UIkit.modal($('#bookmark-modal')).show();
        }
    },

    removeBookmark: function (id) {
        // is id in the list?
        if (this.isStored(id)) {
            // remove from list
            let i = this.bookmarksList.indexOf(id + '');
            this.bookmarksList.splice(i, 1);
            // save updated list in local storage
            this.store();
            // refresh status
            this.setStatus();
        }
    },

    isStored: function (id) {
        // get saved bookmarks
        this.getSavedBookmarks();
        return this.bookmarksList.indexOf(id + '') > -1;
    },

    store: function () {
        // get list as csv string
        let bookmarksToStore = this.bookmarksList.join(',');
        // add to local storage
        if (bookmarksToStore.length > 0) {
            localStorage.setItem('bookmarks', bookmarksToStore);
        }
        else {
            localStorage.removeItem('bookmarks');
        }
    },

    //retrieve current bookmarks
    getSavedBookmarks: function () {
        const savedBookmarks = localStorage.getItem('bookmarks');
        // get array of bookmarked page ids
        if (savedBookmarks !== null) {
            this.bookmarksList = savedBookmarks.split(',');
        }
        else {
            this.bookmarksList = [];
        }
    },

    //mark Save link as added / not added
    setStatus: function () {
        const bmk = this;
        const $links = $('.save-link');
        const unsave = 'Unsave from My Page';
        const save = 'Save to My Page';

        $links.each(function () {
            const $elem = $(this);
            const nid = $elem.data('nid');
            if (bmk.isStored(nid)) {
                $elem.addClass('added')
                    .text(unsave)
                    .attr('title', unsave);
            }
            else {
                $elem.removeClass('added')
                    .text(save)
                    .attr('title', save);
            }
        });
    }
}

// enable bookmarking/unbookmarking pages
$('.save-link').click(function (e) {
    e.preventDefault();

    const $link = $(this);
    const nid = $link.data('nid');

    if ($link.hasClass('added')) {
        //remove
        bookmarks.removeBookmark(nid);
    }
    else {
        //add
        bookmarks.addBookmark(nid);
    }
});

// set link status on load
bookmarks.setStatus();
